import React, {Component} from 'react'
import Slider from 'react-slick'
import shortid from 'shortid'

const items = [
    {
        url: 'http://www.senioren-residenzen.eu',
        src: '/assets/portfolio/senioren-residenzen.jpg',
        title: 'Senioren Residenzen',
        location: 'Germany',
    },
    {
        url: 'http://theme.nycp.com',
        src: '/assets/portfolio/theme.jpg',
        title: 'ThEME',
        location: 'NYCP Inc., USA',
    },
    {
        url: 'http://lincolnisland.com',
        src: '/assets/portfolio/lincolnisland.jpg',
        title: 'Lincoln Island',
        location: 'Lincoln Island LLC, USA',
    },
    {
        url: 'http://palmettosandsrealty.com',
        src: '/assets/portfolio/palmettosandsrealty.jpg',
        title: 'Palmetto Sands Realty',
        location: 'Palmetto Sands Realty, USA',
    },
    {
        url: 'http://www.usalifestylerealestate.com',
        src: '/assets/portfolio/usalifestylerealestate.jpg',
        title: 'USA Lifestyle Real Estate',
        location: 'Freymedia, USA',
    },
    {
        url: 'http://www.gremojadrat.si',
        src: '/assets/portfolio/gremojadrat.jpg',
        title: 'Gremo jadrat',
        location: 'Own project',
    },
    {
        url: 'http://cookiemonster.si',
        src: '/assets/portfolio/cookiemonster.jpg',
        title: 'Cookie monster',
        location: 'Own project',
    },
]

class RecentWork extends Component {
    constructor(props) {
        super(props)
        this.next = this.next.bind(this)
        this.previous = this.previous.bind(this)
    }
    next() {
        this.slider.slickNext()
    }
    previous() {
        this.slider.slickPrev()
    }
    render() {
        const settings = {
            dots: false,
            infinite: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            autoplay: true,
            speed: 500,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                    },
                },
                {
                    breakpoint: 920,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                    },
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    },
                },
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    },
                },
            ],
        }
        return (
            <div className="recent-work">
                <div className="row">
                    <div className="col-lg-3 col-md-12 col-sm-12 items-control ">
                        <h3>Portfolio</h3>
                        <p>Prebrskajte naše nedavne projekte:</p>
                        <button className="items-button" onClick={this.previous}>
                            <i className="fas fa-chevron-left" />
                        </button>
                        <button className="items-button" onClick={this.next}>
                            <i className="fas fa-chevron-right" />
                        </button>
                    </div>
                    <div className="col-lg-9 col-md-12 col-sm-12 items-list">
                        <Slider
                            ref={c => {
                                this.slider = c
                            }}
                            arrows={false}
                            {...settings}
                        >
                            {items.map(item => (
                                <div className="item" key={shortid.generate()}>
                                    <a href={item.url} target="_blank" rel="noopener noreferrer">
                                        <img className="img-slider" alt={item.src} src={item.src} />
                                        <div className="item-text">
                                            <div className="item-title">{item.title}</div>
                                            <div className="item-location">{item.location}</div>
                                        </div>
                                    </a>
                                </div>
                            ))}
                        </Slider>
                    </div>
                </div>
            </div>
        )
    }
}

export default RecentWork



// WEBPACK FOOTER //
// ./src/components/RecentWork.js